<template>
	<div>
		<div class="cart-instructions-wrapper">
			<label class="cart-instructions-label" for="whofor-instructions">{{ label }}</label>
		</div>
		<div class="cart-instructions-wrapper">
			<textarea
				id="whofor-instructions"
				name="whofor-instructions"
				class="cart-instructions"
				cols="30"
				rows="1"
				:placeholder="placeholder"
				v-model="specialInstructionsValue"
				v-on:input="$emit('input', $event.target.value)"
			></textarea>
		</div>
	</div>
</template>

<script>
export default {
	name: "AddItemWhoFor",
	props: {
		// value: {
		// 	type: String
		// },
		specialInstructions: {
			type: String,
		},
		label: {
			type: String,
		},
		placeholder: {
			type: String,
		},
	},
	data: function () {
		return {
			specialInstructionsValue: this.specialInstructions ? this.specialInstructions : "",
		};
	},
};
</script>

<style lang="scss" scoped>
.cart-instructions-wrapper {
	position: relative;
	margin-bottom: 10px;
	text-align: center;
}

.cart-instructions-label {
	font-size: 14px;
	font-weight: 700;
}

.cart-instructions {
	border-bottom: 1px solid;
	border-top: 0;
	border-left: 0;
	border-right: 0;
	width: 80%;
	font-size: 1.6rem;
	resize: none;

	&::placeholder {
		color: $placeholder_color;
	}
	&:focus {
		border-bottom: 2px solid $tomato;
		outline-style: none;
	}
}
</style>
